export default {
  get_all: { method: "get", url: "api/contrapartidas-modelos" },
  show: { method: "get", url: "api/contrapartidas-modelos{/id}" },
  store: { method: "post", url: "api/contrapartidas-modelos" },
  update: { method: "put", url: "api/contrapartidas-modelos{/id}" },
  delete: { method: "delete", url: "api/contrapartidas-modelos{/id}" }
};
